import { expValEquals } from '@confluence/feature-experiments';
import { StatsigConfigurations } from '@confluence/statsig-configurations/entry-points/StatsigConfigurations.ts';

const getExperimentValue = (extensionKey: string): boolean => {
	switch (extensionKey) {
		case 'blog-posts':
		case 'content-report-table':
		case 'contributors':
		case 'include':
		case 'pagetreesearch':
		case 'recently-updated':
		case 'widget':
			return expValEquals('cc_rewrite_legacy_macros_phase_1', 'isEnabled', true);
		case 'contentbylabel':
		case 'pagetree':
		case 'popular-labels':
			return expValEquals('cc_rewrite_legacy_macros_phase_2', 'isEnabled', true);
		default:
			return false;
	}
};

export const isMigratedMacroImplEnabled = (extensionKey: string): boolean => {
	const overrideList = StatsigConfigurations.getStringList(
		'cc_macro_override_to_legacy_renderer',
		[],
	);

	if (overrideList.includes(extensionKey)) {
		return false;
	}

	return getExperimentValue(extensionKey);
};
